<template>
  <div>
    <div class="content">
      <transition name="fade" enter-active-class="animated fadeIn">
        <navigation :navProps="{ spyOffset: 0, items: sections }" v-show="navVisible"></navigation>
      </transition>
      <transition name="custom-classes-transition" enter-active-class="animated fadeIn">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
    <steph-footer></steph-footer>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import StephFooter from '@/components/StephFooter.vue'
import store from '@/store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'index',
  store: store,
  components: {
    Navigation,
    StephFooter
  },
  computed: {
    ...mapGetters(['navVisible', 'sections'])
  },
}
</script>

<style lang="scss">
html {
  position: relative;
  min-height: 100%;
}

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  text-align: left;
  color: #2c3e50;
}

div.content {
  margin-bottom: 180px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.serif {
  font-family: 'Rufina', Times, Palatino, serif;
}

.lh {
  line-height: 2rem;
}

.full-height {
  min-height: 100vh;
}

.section-height {
  min-height: -webkit-calc(100vh - 55px);
  min-height: -moz-calc(100vh - 55px);
  min-height: calc(100vh - 55px);
}

.margin-for-nav {
  padding-top: 55px;
}

section.section {
  margin-bottom: -1px;
}

.section-content {
  h1, h2, h3, h4, h5, h6, p, ul {
    margin-right: 10%;
    margin-left: 10%;
  }
}

.affix-top, .affix-bottom {
  width: 100%;
}

.logo-group-wrapper {
  position: relative;
  @media screen and (min-width: 577px) {
    // sm or above
    .logo-group {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .no-text {
    .card-text {
      display: none;
    }
  }
}

.img-overflow {
  position: relative;
  &.x-hidden {
    overflow-x: hidden;
  }
  &.y-hidden {
    overflow-y: hidden;
  }
  .img-h-100 {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

$white: #FFFFFF;
$black: #213037;
.bg-color-light-gray {
  background-color: #FFF3E9;
}
.bg-color-gray {
  background-color: #C8E0DD;
}
.bg-color-white {
  background-color: $white;
}
.bg-color-yellow {
  background-color: #FBBD16;
}
.bg-color-red {
  background-color: #EE5D5D;
  color: $white;
}
.bg-color-teal {
  background-color: #4CC2C0;
  color: $white;
}
.bg-color-black {
  background-color: #213037;
  color: $white;
}
.bg-color-1 {
  background-color: #F1F3F3;
}
.bg-color-2 {
  background-color: #DDDDDD;
}
.bg-color-3 {
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue